import { render, staticRenderFns } from "./AccountFieldsStepComponent.vue?vue&type=template&id=1ee6fd6a&scoped=true"
import script from "./AccountFieldsStepComponent.vue?vue&type=script&lang=js"
export * from "./AccountFieldsStepComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee6fd6a",
  null
  
)

export default component.exports